import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Week        from '@common/calender/week';
// -------------------------------------------------------

const base_week = ['日','月','火','水','木','金','土']

class CalenderCommon extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      date : Moment().format('YYYY-MM-DD')
    };
  }
  // -------------------------------------------------------
  
  /*
   * 月の変更
   */
  changeDate(num) {
    this.setState({ date: Moment(this.state.date).add(num, 'month').format('YYYY-MM-DD') });
  }
  // -------------------------------------------------------
  
  /*
   * カレンダーデータの取得
   */
  createCalenderBase(props) {
    let start_date = Moment(this.state.date).format('YYYY-MM-') +'01';
    let end_date   = Moment(this.state.date).endOf('month').format('YYYY-MM-DD');
    
    // 週ごとに日付を設定
    let base = [];
    let week = [];
    for( let day = (Moment(start_date).day() * -1); day < parseInt(Moment(end_date).format('D')); day++ ){
      if( week.length >= 7 ){
        base.push(week);
        week = [];
      }
      
      week.push(Moment(start_date).add(day, 'day').format('YYYY-MM-DD'));
    }
    
    // 最終週の設定
    let week_cnt = week.length;
    for( let i = 1; i <= (7 - week_cnt); i++ ){
      week.push(Moment(end_date).add(i, 'day').format('YYYY-MM-DD'));
    }
    base.push(week);
    
    return base;
  }
  // -------------------------------------------------------
  
  render() {
    let date = this.state.date;
    let mode = this.props.mode;
    let schedule = this.props.schedule;
    
    let base = this.createCalenderBase.bind(this)();
    
    return (
      <div className="calender-common">
        <div className="main-date">
          <i className="material-icons" onClick={this.changeDate.bind(this, -1)}>navigate_before</i>
          <div className="main-day">
            <p className="year">{Moment(this.state.date, 'YYYY-MM-DD').format('YYYY')}</p>
            <p className="month">{Moment(this.state.date, 'YYYY-MM-DD').format('M月')}</p>
          </div>
          <i className="material-icons" onClick={this.changeDate.bind(this, 1)}>navigate_next</i>
        </div>
        
        <div className="calender-contents">
          <div className="week-header">
            { base_week.map((day, key) => {
              return <div key={key} className="day"><p className={'day-number day_'+ key}>{day}</p></div>;
            })}
          </div>
          { base.map((week, key) => {
            return <Week key={key} week={week} date={date} mode={mode} schedule={schedule} />
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default CalenderCommon;